<template>
  <section id="add-truck">
    <main style="text-align:left;white-space:normal">
      <add-truck @cancel="$router.push('/trucks')" @save="$router.push('/trucks')" :id="id"/>
    </main>
  </section>
</template>

<script>
import AddTruck from '@/components/Truck'
export default {
  name: 'truck-sign-up',
  components: {
    AddTruck
  },
  mounted () {
    if (this.$route.params && this.$route.params.id) this.id = this.$route.params.id
  },
  data () {
    return { id: undefined }
  }
}
</script>

<style scoped lang="scss">
#add-truck {
  display: table;
}
</style>



// WEBPACK FOOTER //
// src/pages/PageTruckSignUp.vue